<template>
  <div v-if="$store.state.currentOrganization">
    <div class="row">
      <div class="col-md-2 text-right">
        <h6 class="underline">{{ 'customer' | t | titlecase }}</h6>
      </div>
      <div class="col-md-8">
        <template v-if="!is_whitelabel">
          <button class="btn btn-primary mb-3" @click="open_import_from_close_modal()" v-if="show_form">
            Import from Close.com
          </button>
          <sweet-modal ref="import_from_close_modal" title="Import from Close.com">
            <div class="form-group row">
              <label class="col-sm-5 col-form-label">Enter lead id</label>
              <div class="col-sm-7">
                <input class="form-control" v-model="close_com_lead_id" ref="lead_id" />
              </div>
            </div>
            <button class="btn btn-primary mt-4" @click="import_from_close()">Import</button>
          </sweet-modal>
        </template>
        <div class="card mb-5" v-if="show_form">
          <div class="card-body">
            <div>
              <div class="form-group">
                <label>{{ 'country' | t }}</label>
                <select class="form-control" v-model="customer.country_code" required="required">
                  <option v-for="c in countries" :value="c.code">{{ c.name }}</option>
                </select>
              </div>
              <div class="form-group">
                <label>{{ 'company_name' | t }}</label>
                <input class="form-control" v-model="customer.name" />
              </div>
              <div class="form-group">
                <label>{{ 'vat_no' | t }}</label>
                <input class="form-control" v-model="customer.vat_no" />
              </div>
              <div class="form-group">
                <label>{{ 'ean_no' | t }}</label>
                <input class="form-control" v-model="customer.ean" />
              </div>
              <div class="form-group">
                <label>{{ 'customer_reference' | t }} ({{ 'customer_reference_description' | t }})</label>
                <input class="form-control" v-model="customer.customer_reference" />
              </div>
              <div class="form-group">
                <label>{{ 'address_1' | t }}</label>
                <input class="form-control" v-model="customer.address_1" />
              </div>
              <div class="form-group">
                <label>{{ 'address_2' | t }}</label>
                <input class="form-control" v-model="customer.address_2" />
              </div>
              <div class="form-group">
                <div class="row">
                  <div class="col-md-4">
                    <label>{{ 'zip' | t }}</label>
                    <input class="form-control" v-model="customer.zip" />
                  </div>
                  <div class="col-md-8">
                    <label>{{ 'city' | t }}</label>
                    <input class="form-control" v-model="customer.city" />
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label>{{ 'default_locale' | t }}</label>
                <select class="form-control" v-model="customer.default_locale">
                  <option>--</option>
                  <option value="da">da</option>
                  <option value="en">en</option>
                </select>
              </div>
              <div class="form-group">
                <label>{{ 'time_zone' | t }}</label>
                <select class="form-control" v-model="customer.time_zone">
                  <option :value="null">--</option>
                  <option :value="time_zone" v-for="time_zone in all_time_zones">{{ time_zone }}</option>
                </select>
              </div>
              <div class="form-group">
                <label>{{ 'login_method' | t }}</label>
                <select class="form-control" v-model="customer.login_method">
                  <option value="password">Password</option>
                  <option value="oauth">oAuth</option>
                  <option value="any">Any</option>
                </select>
              </div>
              <div class="form-group">
                <label>{{ 'two_factor_enabled' | t }}</label>
                <input class="form-control" type="checkbox" v-model="customer.require_2fa" />
              </div>
              <div class="form-group">
                <label>{{ 'default_ship_page' | t }}</label>
                <select class="form-control" v-model="customer.default_ship_page">
                  <option value="ship-orders">Orders</option>
                  <option value="ship-shipments">Shipments</option>
                </select>
              </div>
              <div class="form-group">
                <label>{{ 'disable_pricequote' | t }}</label>
                <input class="form-control" type="checkbox" v-model="customer.disable_pricequote" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="form-wrapper" v-if="show_form">
      <div class="row" v-if="is_whitelabel">
        <div class="col-md-2 text-right">
          <h6 class="underline">{{ 'plan' | t | titlecase }}</h6>
        </div>
        <div class="col-md-8">
          <div class="card mb-5">
            <div class="card-body">
              <div class="form-group">
                <select class="form-control" v-model="customer.billed_plan">
                  <option v-for="plan in suitable_plans" :value="{ id: plan.id, name: plan.name }">
                    {{ plan.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-2 text-right">
          <h6 class="underline">{{ 'tenant' | t | titlecase }}</h6>
        </div>
        <div class="col-md-8">
          <div class="card mb-5">
            <div class="card-body">
              <div>
                <div class="form-group">
                  <label>{{ 'tenant_name' | t }}</label>
                  <input class="form-control" v-model="customer.tenant_name" :disabled="this.customer.id" />
                </div>
                <div class="form-group">
                  <label>{{ 'currency' | t }}</label>
                  <select class="form-control" v-model="customer.currency" :disabled="customer.id ? true : false">
                    <option value="EUR">{{ 'EUR' }}</option>
                    <option value="DKK">{{ 'DKK' }}</option>
                    <option value="NOK">{{ 'NOK' }}</option>
                    <option value="SEK">{{ 'SEK' }}</option>
                  </select>
                </div>
                <div class="form-group" v-if="!['new', 'migration', 'demo'].includes(customer_type)">
                  <label>{{ 'service_status' | t }}</label>
                  <select class="form-control" v-model="customer.service_status">
                    <option value="running" v-if="['new', 'migration', ''].includes(customer_type)">
                      {{ 'running' }}
                    </option>
                    <option value="test">{{ 'test' }}</option>
                    <option value="disabled">{{ 'disabled' }}</option>
                    <option value="blocked">Blocked - shipments cannot be created</option>
                    <option value="quote">{{ 'quote' }}</option>
                  </select>
                </div>
                <div class="form-group">
                  <label>{{ 'onboarding_status' | t }}</label>
                  <select class="form-control" v-model="customer.onboarding_status">
                    <option value="onboarding">Onboarding</option>
                    <option value="migrating">Migrating</option>
                    <option value="demo">Demo</option>
                    <option value="billing_account">Billing account</option>
                    <option value="drop_point_only">Drop point only</option>
                    <option value="external">External</option>
                    <option value="cancelled">Cancelled</option>
                  </select>
                </div>
                <div class="form-group" v-if="!is_whitelabel">
                  <label>{{ 'payment_method' | t }}</label>
                  <select class="form-control" v-model="customer.payment_method">
                    <option value="credit_card">{{ 'Credit card' }}</option>
                    <option value="invoice">{{ 'Invoice' }}</option>
                    <option value="leverandoerservice" :disabled="this.customer.currency !== 'DKK'">
                      {{ 'Leverandørservice (DKK only)' }}
                    </option>
                    <option value="sepa_direct_debit" :disabled="this.customer.currency !== 'EUR'">
                      {{ 'SEPA Direct Debit (EUR only)' }}
                    </option>
                  </select>
                </div>
                <div class="form-group" v-if="!is_whitelabel">
                  <label>{{ 'payment_term' | t }}</label>
                  <select class="form-control" v-model="customer.payment_term">
                    <option v-for="term in payment_terms" :value="term">{{ term.name }}</option>
                  </select>
                </div>
                <div class="form-group" v-if="!is_whitelabel">
                  <label>{{ 'crm_reference' | t }}</label>
                  <input
                    class="form-control"
                    v-model="customer.crm_reference"
                    :reqiured="!is_whitelabel && subscription.status == 'active'"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="can('read_customers') && customer.id">
        <div class="col-md-2 text-right">
          <h6 class="underline">{{ 'api_limits' | t | titlecase }}</h6>
        </div>
        <div class="col-md-8">
          <div class="card mb-5">
            <div class="card-body">
              <div>
                <div class="form-group">
                  <label>{{ 'api_rate_limit' | t }}</label>
                  <input class="form-control" v-model="customer.api_rate_limit" v-on:blur="duplicate_contacts" :readonly="!can('write_customer_tokens')"/>
                </div>
                <div class="form-group">
                  <label>{{ 'api_rate_period_seconds' | t }}</label>
                  <input
                    class="form-control"
                    v-model="customer.api_rate_period_seconds"
                    v-on:blur="duplicate_contacts"
                    :readonly="!can('write_customer_tokens')"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-2 text-right">
          <h6 class="underline">{{ 'billing_contact' | t | titlecase }}</h6>
        </div>
        <div class="col-md-8">
          <div class="card mb-5">
            <div class="card-body">
              <div>
                <div class="form-group">
                  <label>{{ 'name' | t }}</label>
                  <input class="form-control" v-model="customer.billing_contact_name" v-on:blur="duplicate_contacts" />
                </div>
                <div class="form-group">
                  <label>{{ 'phone' | t }}</label>
                  <input class="form-control" v-model="customer.billing_contact_phone" v-on:blur="duplicate_contacts" />
                </div>
                <div class="form-group">
                  <label>{{ 'email' | t }}</label>
                  <input class="form-control" v-model="customer.billing_contact_email" v-on:blur="duplicate_contacts" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-2 text-right">
          <h6 class="underline">{{ 'admin_contact' | t | titlecase }}</h6>
        </div>
        <div class="col-md-8">
          <div class="card mb-5">
            <div class="card-body">
              <div>
                <div class="form-group">
                  <label>{{ 'name' | t }}</label>
                  <input class="form-control" v-model="customer.admin_contact_name" />
                </div>
                <div class="form-group">
                  <label>{{ 'phone' | t }}</label>
                  <input class="form-control" v-model="customer.admin_contact_phone" />
                </div>
                <div class="form-group">
                  <label>{{ 'email' | t }}</label>
                  <input class="form-control" v-model="customer.admin_contact_email" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row"></div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import Vue from 'vue';
import Api from '@/store/jsonapi';
import Alerts, { handle } from '@/utils/alerts';
import moment from 'moment-es6';
let global_countries = require('i18n-iso-countries');
import zipcodes from '@/utils/danish-zip-codes.js';
import config from '@/config';

export default {
  props: ['value'],
  data: function () {
    return {
      errors: [],
      customer: this.value,
      enabledFeatures: [],
      customer_type: '',
      purchases: [],
      close_com_lead_id: null,
      new_purchase: {
        plan: null,
        description: '',
        quantity: 1,
        unit_price: null
      },
      scopes: [],
      all_time_zones: config.time_zones,
      subscription: {
        plan: null
      },
      payment_terms: [],
      resources: ['users', 'shipments', 'carriers', 'order_channels', 'printers', 'automations', 'return_portals']
    };
  },
  asyncComputed: {
    suitable_plans: async function () {
      let id = this.customer.id;
      let customer_type = this.customer_type;
      let currency = this.customer.currency;

      let plans = [];
      // Ignore currency for white label customers
      if (!this.is_whitelabel) {
        let { data } = await Api.findAllPages('plans', {});
        plans = data;
      } else {
        let { data } = await Api.findAllPages('plans', {
          filter: { currency: currency }
        });
        plans = data;
      }

      if (plans.length > 0) {
        this.scopes = plans[0].meta.feature_scopes;
      }

      if (customer_type == 'new' || customer_type == 'migration') {
        return _.filter(plans, (p) => {
          return p.name.indexOf('Developer') == -1;
        });
      } else {
        return plans;
      }
    }
  },
  computed: {
    is_whitelabel: function () {
      return this.customer.third_party_managed;
    },
    valid() {
      let valid = true;
      if (this.customer_type == 'new' && this.customer.crm_reference == '') valid = false;

      return valid;
    },
    show_form: function () {
      return true;
      return this.is_whitelabel || this.customer.id || this.customer_type != '';
    },
    city: function () {
      return zipcodes[this.customer.zip];
    },
    countries: function () {
      var cs = global_countries.getNames(config.locale);
      return _.chain(cs)
        .map((name, code) => {
          return { code: code, name: name };
        })
        .sortBy(['name', 'asc'])
        .unshift({ code: '', name: '' })
        .unshift({ code: 'DK', name: cs.DK })
        .unshift({ code: 'GB', name: cs.GB })
        .value();
    }
  },
  watch: {
    'customer.zip': function () {
      let city = zipcodes[this.customer.zip];
      if (city && this.customer.country_code === 'DK') {
        this.customer.city = city;
      }
    },
    'customer.country_code': function () {
      if (this.customer && !this.customer.id) {
        if (this.customer.country_code == 'DK') {
          this.customer.currency = 'DKK';
        } else {
          this.customer.currency = 'EUR';
        }
      }
    },
    suitable_plans: function () {
      if (
        (!this.subscription.plan ||
          !_.find(this.suitable_plans, (plan) => {
            plan.id == this.subscription.plan.id;
          })) &&
        this.suitable_plans.length > 0
      ) {
        this.subscription.plan = this.suitable_plans[0];
      }
    },
    'subscription.plan': function () {
      if (!this.subscription.plan) return;
      _.forOwn(
        _.omit(this.subscription.plan, 'id', 'created_at', 'updated_at', 'visible', 'usage_period'),
        (value, key) => {
          Vue.set(this.subscription, key, value);
        }
      );
      this.enabledFeatures = this.getFeaturesAsArray(this.subscription);
    },
    'customer.name': function () {
      if (this.customer.id) return;
      this.customer.tenant_name = this.slugify(this.customer.name);
    }
  },
  methods: {
    open_import_from_close_modal() {
      this.$refs.import_from_close_modal.open();
      this.$refs.lead_id.focus();
    },
    import_from_close: handle(async function () {
      await Api.find('close_com_lead', this.close_com_lead_id).then((response) => {
        let lead = response.data.lead;

        this.customer.name = lead.name;
        this.customer.vat_no =
          lead['custom.lcf_J3O6HNxxaOLfi6ZNhLZWDrTkJThFiAkxlUps9cMu7q8'] || lead['custom']['#4 VAT No.'];

        this.customer.address_1 = lead.addresses[0].address_1;
        this.customer.address_2 = lead.addresses[0].address_2;
        this.customer.city = lead.addresses[0].city;
        this.customer.state = lead.addresses[0].state;
        this.customer.zip = lead.addresses[0].zipcode;
        this.customer.country_code = lead.addresses[0].country;

        this.customer.admin_contact_email = lead.contacts[0].emails[0].email;
        this.customer.admin_contact_name = lead.contacts[0].name;
        this.customer.admin_contact_phone = lead.contacts[0].phones[0].phone;

        this.customer.billing_contact_email = lead.contacts[0].emails[0].email;
        this.customer.billing_contact_name = lead.contacts[0].name;
        this.customer.billing_contact_phone = lead.contacts[0].phones[0].phone;

        this.customer.crm_reference = this.close_com_lead_id;

        this.$refs.import_from_close_modal.close();
      });
    }),
    add_purchase() {
      this.purchases.push(this.new_purchase);
      this.new_purchase = {
        plan: null,
        quantity: 1,
        description: '',
        unit_price: null
      };
    },
    set_customer_type(t) {
      this.customer_type = t;
      switch (t) {
        case 'new':
          this.customer.service_status = 'test';
          this.subscription.status = 'active';
          this.customer.onboarding_status = 'demo';
          break;
        case 'migration':
          this.customer.service_status = 'test';
          this.subscription.status = 'active';
          this.customer.onboarding_status = 'migrating';
          break;
        case 'demo':
          this.customer.service_status = 'test';
          this.subscription.status = 'trial';
          this.customer.onboarding_status = 'demo';
          break;
      }
    },
    changeFeatureInclusion(feature) {
      let featureIndex = this.enabledFeatures.findIndex((feat) => feat === feature);

      if (featureIndex >= 0) {
        this.enabledFeatures.splice(featureIndex, 1);
      } else {
        this.enabledFeatures.push(feature);
      }
    },
    getFeaturesAsArray(subscription) {
      if (subscription && subscription.feature_scopes) {
        return subscription.feature_scopes.split(' ');
      }

      return [];
    },
    slugify(text) {
      return text
        .toString()
        .toLowerCase()
        .replace(/\s+/g, '-') // Replace spaces with -
        .replace(/[^\w\-]+/g, '') // Remove all non-word chars
        .replace(/\-\-+/g, '-') // Replace multiple - with single -
        .replace(/^-+/, '') // Trim - from start of text
        .replace(/-+$/, ''); // Trim - from end of text
    },
    async save(event) {
      /*this.subscription.feature_scopes = this.enabledFeatures.reduce((scopeString, feature) => {
          let featureString = feature
          if (scopeString.length === 0) {
            return featureString
          } else {
            return scopeString + ' ' + featureString
          }
        }, '')

        this.customer.subscription = this.subscription */

      this.$emit('save', event);
    },

    duplicate_contacts() {
      if (this.customer.billing_contact_name != '' && this.customer.admin_contact_name == '')
        this.customer.admin_contact_name = this.customer.billing_contact_name;

      if (this.customer.billing_contact_phone != '' && this.customer.admin_contact_phone == '')
        this.customer.admin_contact_phone = this.customer.billing_contact_phone;

      if (this.customer.billing_contact_email != '' && this.customer.admin_contact_email == '')
        this.customer.admin_contact_email = this.customer.billing_contact_email;
    }
  },
  mounted: async function () {
    if (this.customer == null) {
      this.customer = _newCustomer();
      this.customer.onboarding_status = 'demo';
    }

    let { data } = await Api.findAllPages('payment_terms');

    this.payment_terms = data;

    if (this.customer.billed_plan) {
      this.customer.billed_plan = _.pick(this.customer.billed_plan, ['id', 'name']);
    }
  }
};
</script>
